import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app';
import { isFrozenRelease } from '@/app/releasePrefix';
import { applyThemePreference, readThemePreference } from '@/lib/theme';

import '@/styles/global.css';

// Before the first render, so a saved dark choice never flashes the light palette first.
applyThemePreference(readThemePreference());

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Elemento #root não encontrado em index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Registered only for production builds, and only by the copy published at the root.
//
// In dev the worker would serve stale precached assets and silently defeat HMR. From a frozen
// `/vX.Y.Z/` copy it is worse than useless: a release under review does not need offline
// support, and a second worker on the same origin competes with the root's for control of the
// same navigations. The root's worker claims scope `/`, so before this it intercepted requests
// for `/v0.4.0/...` and answered them with the *root* application shell -- which then 404'd on
// a path it does not know. Anyone who had opened the site once could no longer open any frozen
// release at all.
if (import.meta.env.PROD && !isFrozenRelease()) {
  void import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({ immediate: true });
  });
}
